import React from "react";

const Footer = () => {
  const date = new Date();

  const year = date.getFullYear();

  return (
    <div className="h-12 flex justify-center items-center bg-commonfill">
      <p>@{year} Transforma. All Rights Reserved.</p>
    </div>
  );
};

export default Footer;
